export enum ROLES {
  ROLE_SALES = "ROLE_SALES",
  ROLE_ADMIN = "ROLE_ADMIN",
  ROLE_ORG_ADMIN = "ROLE_ORG_ADMIN",
  ROLE_TRACK = "ROLE_TRACK"
}

export const Sports = [
  { value: "Baseball" },
  { value: "Basketball" },
  { value: "Football" },
  { value: "Volleyball" },
  { value: "Golf" },
  { value: "LaCrosse" },
  { value: "Soccer" },
  { value: "Softball" },
  { value: "Tennis" },
  { value: "Hockey" },
  { value: "Rugby" },
  { value: "Wrestling" },
  { value: "Other" }
];
export enum InvitePeopleToRegisterModalTabContext {
  Players = "Players",
  Teams = "Teams"
}
